module.exports = __webpack_public_path__ + "img/logo_fsn.84e5c40d.png";